import { Input } from "antd";
import React from "react";

export default function LabelPass({
  label,
  name,
  onChange,
  value,
  placeholder,
  disabled,
  readOnly,
  labelStyle
}) {
  return (
    <>
      <div className="inputLabel" style={labelStyle}>{label}</div>
      <Input.Password
        readOnly={readOnly}
        disabled={disabled}
        name={name}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
      />
    </>
  );
}
